import React, { useCallback } from 'react'

import { Label } from '@/atoms/Typography'
import Grid from '@/molecules/Grid'
import NoResults from '@/organisms/SearchResults/NoResults'

import { StyledFiltersResults, } from './styles'
const FiltersResults = ({
  error = null,
  results = [],
  totalItems,
  currentPage,
  totalPages,
  getData,
  setTotalPages,
  setTotalItems,
  loading = false,
  noResult = {},
}) => {
  const handleLoadMore = useCallback(async () => {
    if (!getData) return
    const nextPage = currentPage + 1
    if (nextPage >= totalPages) return

    const data = await getData({
      page: nextPage,
      replace: false,
    })

    if (data) {
      if (setTotalPages) setTotalPages(data.nbPages)
      if (setTotalItems) setTotalItems(data.nbHits)
    }
  }, [getData, currentPage, totalPages, setTotalPages, setTotalItems])

  return (
    <StyledFiltersResults>
      {
        error &&
        <Label className='error' as="strong" bold typo="labelBig">{error}</Label>
      }

      {
        results &&
        !!results.length &&
        <Grid
          totalItems={totalItems}
          showTotalItemLabel
          list={results}
          type="SearchCard"
          onLoadMore={getData ? handleLoadMore : undefined}
        />
      }

      {
        results &&
        results.length === 0 &&
        !loading &&
        <NoResults
          {...noResult}
        />
      }
    </StyledFiltersResults>
  )
}


export default FiltersResults
